import React, { useCallback } from "react";
import ArcticIconFont from "@/icon";
import { useStore, useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import styles from "./index.module.less";

function Toolbar() {
  const { t, i18n } = useTranslation();
  const { select } = useStore();
  const dispatch = useDispatch();
  const weather = useSelector(select.panel.selectWeather);
  const port = useSelector(select.panel.selectPort);
  const chart = useSelector(select.panel.selectChart);

  const closePanel = useCallback(
    (value) => {
      dispatch.panel.closePanel(value);
    },
    [dispatch]
  );

  const changeLanguage = useCallback(
    (lng) => {
      i18n.changeLanguage(lng);
    },
    [i18n]
  );

  return (
    <div className={styles.toolbar}>
      <div
        className={weather ? "item active" : "item"}
        onClick={(e) => closePanel("weather")}
      >
        <ArcticIconFont type="icon-qixiang" />
        <span className="label">{t("temperature")}</span>
      </div>
      <div
        className={port ? "item active" : "item"}
        onClick={(e) => closePanel("port")}
      >
        <ArcticIconFont type="icon-gangkou" />
        <span className="label">{t("port")}</span>
      </div>
      <div
        className={chart ? "item active" : "item"}
        onClick={(e) => closePanel("chart")}
      >
        <ArcticIconFont type="icon-fengxian" />
        <span className="label">{t("factor")}</span>
      </div>
      {i18n.language === "zh" ? (
        <div
          className="item active"
          style={{ marginLeft: 20 }}
          onClick={(e) => changeLanguage("en")}
        >
          English
        </div>
      ) : (
        <div
          className="item active"
          style={{ marginLeft: 20 }}
          onClick={(e) => changeLanguage("zh")}
        >
          中文
        </div>
      )}
    </div>
  );
}

export default Toolbar;
